<div class="navi-route-map">
  <svg [attr.viewBox]="'0 0 ' + viewBoxWidth + ' ' + viewBoxHeight" role="img" [attr.aria-label]="ariaLabel">
    <defs>
      <!--
        userSpaceOnUse: a flat segment has a bounding box of almost no height, which would clip an
        objectBoundingBox filter or gradient away entirely.
      -->
      <filter [attr.id]="glowId()" filterUnits="userSpaceOnUse"
              [attr.x]="-40" [attr.y]="-40"
              [attr.width]="viewBoxWidth + 80" [attr.height]="viewBoxHeight + 80">
        <feGaussianBlur stdDeviation="4" result="blurred"/>
        <feMerge>
          <feMergeNode in="blurred"/>
          <feMergeNode in="SourceGraphic"/>
        </feMerge>
      </filter>

      <!-- One gradient per segment: it fades from the colour of a stop into the colour of the next.
           The stops carry a level class so the palette stays in shared/styles. -->
      <linearGradient *ngFor="let segment of segments; let i = index"
                      [attr.id]="segment.id" gradientUnits="userSpaceOnUse"
                      [attr.x1]="points[i].x" [attr.y1]="points[i].y"
                      [attr.x2]="points[i + 1].x" [attr.y2]="points[i + 1].y">
        <stop offset="0%" [attr.class]="'level-' + segment.fromKey" [style.stop-color]="'var(--level-primary)'"/>
        <stop offset="100%" [attr.class]="'level-' + segment.toKey" [style.stop-color]="'var(--level-primary)'"/>
      </linearGradient>
    </defs>

    <!-- The road bed under the coloured segments -->
    <path [attr.d]="routeD" fill="none" class="route-bed" stroke-width="14" stroke-linecap="round"/>

    <!-- Reference path for the travelling navigator; never painted -->
    <path #routePath [attr.id]="pathId()" [attr.d]="routeD" fill="none" stroke="none"/>

    <path *ngFor="let segment of segments"
          [attr.d]="segment.d" fill="none"
          [attr.stroke]="'url(#' + segment.id + ')'" stroke-width="7" stroke-linecap="round"
          [attr.filter]="'url(#' + glowId() + ')'"/>

    <!-- Road markings, flowing towards the next stop -->
    <path *ngIf="!reduceMotion" class="route-flow" [attr.d]="routeD" fill="none"
          stroke-width="2.5" stroke-linecap="round" stroke-dasharray="3 26">
      <animate attributeName="stroke-dashoffset" from="0" to="-29" dur="1.1s" repeatCount="indefinite"/>
    </path>

    <!-- Stops -->
    <g *ngFor="let step of steps; let i = index"
       [attr.class]="'route-stop level-' + step.levelKey"
       [attr.transform]="'translate(' + points[i].x + ' ' + points[i].y + ')'">
      <circle *ngIf="!reduceMotion" class="stop-pulse" r="11" fill="none" stroke-width="2"
              [style.animation-delay]="(i * 0.35) + 's'"/>
      <circle class="stop-ring" r="11" stroke-width="3"/>
      <circle class="stop-core" r="5"/>

      <text class="stop-label" x="0" y="-26" text-anchor="middle">{{step.topLabel}}</text>

      <text class="stop-milestone" *ngIf="step.bottomLabel" x="0" y="34" text-anchor="middle">
        {{step.bottomLabel}}<tspan class="stop-milestone-suffix" *ngIf="step.bottomSuffix"> {{step.bottomSuffix}}</tspan>
      </text>
    </g>

    <!-- The navigator keeps driving the whole route; decoration, not data -->
    <g *ngIf="showNavigator && !reduceMotion && routeD" class="route-navigator">
      <circle r="13" class="navigator-glow" [attr.filter]="'url(#' + glowId() + ')'"/>
      <circle r="11" class="navigator-body" stroke-width="1.5"/>
      <image [attr.href]="navigatorIcon" x="-7.5" y="-7.5" width="15" height="15"
             preserveAspectRatio="xMidYMid meet"/>
      <animateMotion dur="6s" repeatCount="indefinite" calcMode="linear">
        <mpath [attr.href]="'#' + pathId()"/>
      </animateMotion>
      <animate attributeName="opacity" dur="6s" repeatCount="indefinite"
               values="0;1;1;1;0" keyTimes="0;0.1;0.55;0.9;1"/>
    </g>

    <!-- Current position -->
    <g *ngIf="pin" class="route-pin" [attr.transform]="'translate(' + pin.x + ' ' + pin.y + ')'">
      <circle *ngIf="!reduceMotion" class="pin-pulse" r="14"/>
      <g transform="scale(1.5) translate(-12 -30)">
        <path class="pin-body"
              d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"
              stroke-width="1.4" stroke-linejoin="round"/>
        <circle class="pin-hole" cx="12" cy="9" r="3"/>
      </g>
    </g>
  </svg>

  <!-- The bubble is HTML on top of the SVG, so its text scales with the page, not the viewBox -->
  <div class="route-bubble" *ngIf="pin && marker" [style.left.%]="bubbleLeft()" [style.top.%]="bubbleTop()">
    <div class="bubble-body d-inline-flex align-items-center">
      <span class="bubble-label" *ngIf="marker.label">{{marker.label}}</span>
      <span class="bubble-value" [class]="'level-' + markerColorKey()">{{marker.value}}</span>
      <span class="bubble-badge" *ngIf="marker.badge">{{marker.badge}}</span>
    </div>
  </div>
</div>
